import React from 'react';
import { observer, inject } from 'mobx-react';

import Container from './Container';
import Display from './Display';
import EditButton from './EditButton';

export default inject('page')(
  observer(() => (
    <Container>
      <Display />
      <EditButton />
    </Container>
  )),
);
